import React from "react";
import { Award, Users, Heart, Target } from "lucide-react";
import Logo_Bg from "../asset/logo_bg.jpeg";
import "./About.css";

const About = () => {
  const values = [
    {
      icon: Award,
      title: "Excellence",
      description:
        "Every stitch reflects our commitment to uncompromising quality and precision",
    },
    {
      icon: Users,
      title: "Personalization",
      description:
        "Each garment is tailored to celebrate your unique style and personality",
    },
    {
      icon: Heart,
      title: "Craftsmanship",
      description:
        "Traditional techniques blended with contemporary design sensibilities",
    },
    {
      icon: Target,
      title: "Attention to Detail",
      description:
        "Meticulous care in every measurement, fabric choice, and finishing touch",
    },
  ];

  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="about-hero-content">
          <h1 className="about-hero-title">Our Story</h1>
          <p className="about-hero-subtitle">
            Where Tradition Meets Innovation
          </p>
        </div>
      </section>

      <section className="about-story">
        <div className="about-story-container">
          <div className="about-story-image">
            <img src={Logo_Bg} alt="PSD Designers - Crafting Excellence" />
          </div>

          <div className="about-story-text">
            <h2 className="about-section-title">The Art of Bespoke Fashion</h2>

            <p className="about-paragraph">
              Founded with a passion for excellence, PSD Designers has been
              transforming fabric into wearable art for over a decade. What
              began as a dream to bring authentic, handcrafted tailoring to
              Coimbatore has blossomed into a trusted name synonymous with
              quality, elegance, and personalized service.
            </p>

            <p className="about-paragraph">
              Our journey is rooted in the belief that clothing is more than
              just fabric—it's an expression of identity, confidence, and
              personal style. Every garment that leaves our shop carries with it
              the legacy of traditional craftsmanship, enhanced by contemporary
              design sensibilities.
            </p>

            <p className="about-paragraph">
              At PSD Designers, we specialize in custom tailoring, intricate
              Aari work, and stunning bridal couture. Our master tailors bring
              decades of combined experience, ensuring that each piece is
              meticulously crafted to perfection. From the initial consultation
              to the final fitting, we work closely with our clients to create
              garments that exceed expectations.
            </p>

            <p className="about-paragraph">
              We take pride in our attention to detail, our commitment to
              quality materials, and our dedication to understanding each
              client's unique vision. Whether it's a wedding ensemble, formal
              wear, or everyday elegance, we approach every project with the
              same level of care and artistry.
            </p>
          </div>
        </div>
      </section>

      <section className="about-timeline">
        <div className="about-timeline-container">
          <h2 className="about-section-title centered">Our Journey</h2>
          <p className="about-section-subtitle centered">
            A story woven with passion, dedication, and 19 years of excellence
          </p>

          <div className="journey-story">
            <p className="journey-paragraph">
              For nearly two decades, our master tailor and designer has been
              crafting dreams into reality, one stitch at a time. What began as
              a young apprentice's fascination with the art of tailoring in 2005
              has evolved into a legacy of excellence that defines PSD Designers
              today.
            </p>

            <p className="journey-paragraph">
              With 19 years of hands-on experience, our founder has mastered the
              intricate balance between traditional craftsmanship and
              contemporary design. From learning the fundamentals of pattern
              making and fabric selection to perfecting the delicate art of Aari
              work and embroidery, every year has added a new dimension to our
              expertise.
            </p>

            <p className="journey-paragraph">
              Over the years, we've had the privilege of creating thousands of
              garments—each one unique, each one special. From elegant bridal
              ensembles that make wedding days unforgettable to sophisticated
              formal wear that commands attention, our journey has been enriched
              by the trust and satisfaction of our valued clients.
            </p>

            <p className="journey-paragraph">
              Today, PSD Designers stands as a testament to the power of
              dedication, continuous learning, and an unwavering commitment to
              quality. Our 19 years of experience isn't just about time—it's
              about the countless hours spent perfecting techniques,
              understanding fabrics, studying trends, and most importantly,
              listening to our clients' dreams and bringing them to life with
              precision and artistry.
            </p>

            <p className="journey-paragraph">
              As we look to the future, we carry forward the wisdom of nearly
              two decades while embracing innovation and new possibilities. Our
              journey continues, and we invite you to be a part of our story—
              where your vision meets our expertise, and together, we create
              something truly extraordinary.
            </p>
          </div>
        </div>
      </section>

      <section className="about-values">
        <div className="about-values-container">
          <h2 className="about-section-title centered">Our Values</h2>
          <p className="about-section-subtitle centered">
            The principles that guide every stitch
          </p>

          <div className="values-grid">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div key={index} className="value-card">
                  <div className="value-icon">
                    <IconComponent size={32} />
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="about-cta-container">
          <h2 className="about-cta-title">
            Experience the PSD Designers Difference
          </h2>
          <p className="about-cta-text">
            Visit our shop in Coimbatore and discover how we can bring your
            fashion vision to life
          </p>
          <a href="tel:+919585693060" className="about-cta-button">
            Book Your Consultation
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
